import $ from 'jquery';
import MultiGroupReportStyle from './MultiGroupReport.module.scss';
import * as React from 'react';
import { Injector } from 'Core';
import { UnitPresentation, UnitSystem } from 'MeasurementsCalculations';
import { IReportDataService, IReportDataConversionService } from 'Services';
import * as Data from 'Data';
import {
  IOptimizerControlParams,
  IMultiShotControlParams,
  ISkidAndRollControlParams,
  ISponsorDetailsProps,
  IInstructorMessageControlProps,
  IClubControlProps,
  INormalizedCheckboxTextProps,
  IFooterWithCommercialProps,
  IVideoControlProps,
  ITrajectoryControlParams,
  IShareButtonsProps,
  InstructorMessageControl,
  SponsorDetails,
  ReportWithNoData,
  FooterWithCommercial,
  HeaderWithCommercials,
  VideoControl,
  TrajectoryControl,
  OptimizerControl,
  DispersionControl,
  MultiShotControl,
  SkidAndRollControl,
  ClubControl,
  ViewButton,
  ConfigurationViewButton,
  ShareButtons,
  StrokesGroupButton,
  IDispersionControlProps,
  IHeaderWithCommercialProps,
  ImageHandler,
  NormalizedCheckboxText,
} from 'Components';
import { IPrintedLegendsProps } from './PrintedLegends/IPrintedLegendsProps';
import { PrintedLegends } from './PrintedLegends/PrintedLegends';
import { autorun, action } from 'mobx';
import { observer } from 'mobx-react';
import { GeneralReportStore, MultiShotHelpers } from 'Reports';
import { tps } from '../../Tps/TpsCallback';
import * as IMultiGroupReportProps from './IMultiGroupReportProps';
import { ReportComponentState } from 'Reports/Helpers/models';
import { NormalizationSettingsType } from 'Components/NormalizationSettings/configs';

@observer
export class MultiGroupReport extends React.Component<
  IMultiGroupReportProps.IMultiGroupReportProps,
  ReportComponentState
> /*BaseReport*/ {
  private reportDataService: IReportDataService = Injector.resolve<IReportDataService>(
    'IReportDataService'
  );
  private dataConversionService: IReportDataConversionService = Injector.resolve<
    IReportDataConversionService
  >('IReportDataConversionService');
  private subscriptions = new Array<any>();
  private reportStore: GeneralReportStore;
  private skipOneTimeHistoryPush = false;
  constructor(props: IMultiGroupReportProps.IMultiGroupReportProps) {
    super(props, undefined);
    this.reportStore = props.store;
    this.state = {
      isUpdatingReport: false,
    };
    tps.reportConfiguration(this.reportStore);

    MultiShotHelpers.loadDataToState(
      this.reportDataService,
      this.reportStore,
      this.props.spinnerEventHandler
    ).done(
      action(() => {
        //Url state has higher priority, so we overwrite.
        MultiShotHelpers.deserializeStateFromUrl(this.reportStore);
        //TODO: check if autorun is before or after render.
        this.subscriptions.push(
          autorun(() => {
            if (this.skipOneTimeHistoryPush) {
              this.skipOneTimeHistoryPush = false;
              return;
            }
            const queryString = '?' + MultiShotHelpers.serializeStateToUrlQuery(this.reportStore);
            const pathName = window.location.pathname;
            const newUrl = pathName + queryString;
            window.history.pushState(this.reportStore.toReportConfiguration(), '', newUrl);
            this.reportStore.reportPrintUrl = newUrl + '&p=1&rfu';
            this.reportStore.currentUrl = newUrl;
            if (this.reportStore.isWeb) {
              this.reportStore.shareLink = window.location.origin + newUrl + '&rfu';
            }
          })
        );
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        //move url's state managing to separate module
        window.addEventListener('popstate', (e: PopStateEvent) => {
          if (!e.state) {
            return;
          }
          if (!self) {
            console.error('no state');
          }
          const reportConfigs = e.state as Data.IReportConfiguration;
          self.skipOneTimeHistoryPush = true;
          self.reportStore.fromReportConfiguration(reportConfigs);
          self.reportStore.currentUrl = window.location.pathname + window.location.search;
        });
      })
    );

    this.reportStore.showOptimizerTutorial = MultiShotHelpers.checkIfOptimizerTutorialShouldBeShown();
  }

  componentWillUnmount(): void {
    this.subscriptions.forEach(disposer => disposer());
  }

  componentWillReceiveProps() {
    this.setState({
      isUpdatingReport: false,
    });
  }

  @action.bound
  private onInstructorMessageChanged(message: string) {
    if (message) {
      this.reportStore.instructorMessage = message;
    }
  }
  @action.bound
  private onSelectedVideosChanged(videos: Data.IReportVideo[]) {
    if (videos) {
      MultiShotHelpers.onSelectedVideosChanged(videos, this.reportStore);
    }
  }
  @action.bound
  private loadTiles(): void {
    MultiShotHelpers.loadTiles(this.reportStore);
  }
  @action.bound
  private addTile(param: string, visibleCount: number): boolean {
    return MultiShotHelpers.addTile(param, visibleCount, this.reportStore);
  }
  @action.bound
  private displayStrokesGroup(index: number) {
    MultiShotHelpers.displayStrokesGroup(index, this.reportStore, tps);
  }
  @action.bound
  private selectVideo(
    stroke: Data.IReportMeasurement,
    measurementGroup: Data.IReportMeasurementGroup
  ) {
    this.selectShot(stroke, measurementGroup);
    this.scrollToVideoComponent();
    this.reportStore.selectedView = Data.ViewType.Video;
  }
  @action.bound
  private hideOptimizerTutorial() {
    this.reportStore.showOptimizerTutorial = false;
  }
  @action.bound
  private selectOptimizerView(name: string) {
    if (name) {
      this.reportStore.selectedOptimizerView = Data.GetOptimizerView(name);
    }
  }
  @action.bound
  private selectOptimizedType(optimizedType: Data.IOptimizationType) {
    this.reportStore.selectedOptimizedType = optimizedType;
  }
  @action.bound
  private doNotShowOptimizerAgain() {
    MultiShotHelpers.setToDontShowOptimizerTutorial();
  }
  @action.bound
  private disableTile(index: number) {
    this.reportStore.measurementParameters[index].isVisible = false;
  }
  @action.bound
  private hideSingleShot(
    stroke: Data.IReportMeasurement,
    measurementGroup: Data.IReportMeasurementGroup
  ) {
    if (stroke.isVisible) {
      // Clearing selected stroke if visibility of stroke has changed
      if (this.reportStore.selectedStroke) {
        if (this.reportStore.selectedStroke.id === stroke.id) {
          this.cleanSelectedShot();
        }
      }
    }

    stroke.isVisible = !stroke.isVisible;
    const normalStrokes = measurementGroup.normalStrokes.filter(x => x.id === stroke.id);
    if (normalStrokes.length > 0) {
      normalStrokes[0].isVisible = stroke.isVisible;
    }

    const normalizedStrokes = measurementGroup.normalizedStrokes.filter(x => x.id === stroke.id);
    if (normalizedStrokes.length > 0) {
      normalizedStrokes[0].isVisible = stroke.isVisible;
    }

    if (this.reportStore.selectedAverage) {
      this.selectAverage((measurementGroup && measurementGroup.strokes) ?? [], measurementGroup);
    }
  }
  @action.bound
  private changeUnit(newValue: string) {
    const unitSystem = Data.GetSymbolUnitSystem(newValue) || UnitSystem.Metric;
    this.reportStore.unitPresentation = new UnitPresentation(unitSystem);
    this.reportStore.selectedUnit = newValue;
  }

  @action.bound
  private cleanSelectedShot() {
    MultiShotHelpers.cleanSelectedShot(this.reportStore);
  }

  @action.bound
  private selectShot(
    stroke: Data.IReportMeasurement,
    measurementGroup: Data.IReportMeasurementGroup
  ) {
    MultiShotHelpers.selectShot(stroke, measurementGroup, this.reportStore);
  }

  @action.bound
  private selectAverage(
    strokes: Array<Data.IReportMeasurement>,
    measurementGroup: Data.IReportMeasurementGroup
  ) {
    MultiShotHelpers.selectAverage(strokes, measurementGroup, this.reportStore);
  }

  @action.bound
  private collapseStrokesGroup(measurementGroup: Data.IReportMeasurementGroup) {
    measurementGroup.isCollapsed = !measurementGroup.isCollapsed;
  }
  //todo: no jquery
  private scrollToVideoComponent() {
    $('#view-buttons').ready(function() {
      $('html, body')
        .delay(300)
        .animate(
          {
            scrollTop: $('#view-buttons').offset()?.top,
          },
          2000
        );
    });
  }

  @action.bound
  private updateUnitOnTiles(): void {
    MultiShotHelpers.updateUnitOnTiles(this.reportStore);
    // TODO: Check if commenting this out is OK or is it necessary for something?
    //if (this.reportStore.selectedAverage) {
    //    this.selectAverage(this.reportStore.selectedGroupOfStrokes.strokes, this.reportStore.selectedGroupOfStrokes);
    //}
  }
  @action.bound
  private onDispersionModeChange(mode: string) {
    if (mode) {
      this.reportStore.selectedDispersionMode = Data.GetDispersionMode(mode);
    }
  }
  @action.bound
  private onSelectedStrokeChange(stroke: Data.IReportMeasurement | undefined) {
    this.reportStore.selectedStroke = stroke;
  }
  @action.bound
  private onSelectedClubChange(club: string) {
    this.reportStore.clubType = club;
  }
  @action.bound
  private onSelectedGroupOfStrokesChange(strokeGroup: Data.IReportMeasurementGroup | undefined) {
    this.reportStore.selectedGroupOfStrokes = strokeGroup;
  }
  @action.bound
  private onSelectedAverageChange(averange: Data.IReportMeasurement | undefined) {
    this.reportStore.selectedAverage = averange;
  }
  //@action.bound
  //private setAdditionalInfoUrl(str) {
  //    console.log("setAdditionalInfoUrl");
  //    //alert(str);
  //};
  @action.bound
  toggleNormalization(value: boolean) {
    this.reportStore.showNormalizedData = value;
    // this.setState({
    //   isUpdatingReport: true,
    // });
    // this.props.updateReportData?.();
    this.changeStrokesValues();
  }

  @action.bound
  setNormalizationSettings = (normalizationSettings: NormalizationSettingsType) => {
    this.reportStore.normalizationSettings = normalizationSettings;
    this.setState({
      isUpdatingReport: true,
    });
    this.props.updateReportData?.(normalizationSettings);
  };

  @action.bound
  onSelectStroke(group: Data.IReportMeasurementGroup, stroke: Data.IReportMeasurement) {
    MultiShotHelpers.onSelectStroke(group, stroke, this.reportStore);
  }

  @action.bound
  onCleanSelectedShot() {
    MultiShotHelpers.onCleanSelectedShot(this.reportStore);
  }

  @action.bound
  changeStrokesValues() {
    MultiShotHelpers.changeStrokesAccordingToIsNormalized(this.reportStore);
  }
  @action.bound
  private onClickMailButton() {
    MultiShotHelpers.onClickMailButton(this.reportStore);
  }

  @action.bound
  private shareOnTwitterOnClick() {
    MultiShotHelpers.shareOnTwitterOnClick(this.reportStore);
  }

  @action.bound
  private shareOnFacebookOnClick() {
    MultiShotHelpers.shareOnFacebookOnClick(this.reportStore);
  }

  render() {
    const isMultiGroupOrSingleGroupReport =
      this.reportStore.reportKind === Data.ReportKind.multiGroupReport ||
      this.reportStore.reportKind === Data.ReportKind.singleGroupReport;
    const isPuttingMultiGroupOrPuttingSingleGroupReport =
      this.reportStore.reportKind === Data.ReportKind.puttingMultiGroupReport ||
      this.reportStore.reportKind === Data.ReportKind.puttingSingleGroupReport;
    const isDisabledDispersionView =
      this.reportStore.editModeInTps && !this.reportStore.dispersionOn ? 'disabled-view' : '';
    const isDisabledTrajectoryView =
      this.reportStore.editModeInTps && !this.reportStore.trajectoryOn ? 'disabled-view' : '';
    const isDisabledOptimizerView =
      this.reportStore.editModeInTps && !this.reportStore.optimizerOn ? 'disabled-view' : '';
    const isDisabledClubDataView =
      this.reportStore.editModeInTps && !this.reportStore.clubDataOn ? 'disabled-view' : '';
    const isDisabledVideoView =
      this.reportStore.editModeInTps && !this.reportStore.videoOn ? 'disabled-view' : '';
    const isDisabledSkidAndRollView =
      this.reportStore.editModeInTps && !this.reportStore.skidAndRollOn ? 'disabled-view' : '';
    const isInEditModeInTps = this.reportStore.editModeInTps;
    const isNormalizedCheckNotChecked = !this.reportStore.showNormalizedData
      ? 'glyphicon-unchecked'
      : 'glyphicon-check';
    return (
      this.reportStore.showReport && (
        <div className={MultiGroupReportStyle.MultiGroupReport}>
          {
            <div>
              {isInEditModeInTps && <div className={MultiGroupReportStyle.dimmedBackground}></div>}
              {this.reportStore.isTps && (
                <div className={MultiGroupReportStyle.editModeBarAndConfigurationButtonsContainer}>
                  <div
                    className={MultiGroupReportStyle.editModeBar}
                    onClick={() => MultiShotHelpers.changeToEditMode(this.reportStore)}
                  >
                    {!this.reportStore.editModeInTps && (
                      <p>
                        <span>Click here to edit the report content</span>
                      </p>
                    )}
                    {this.reportStore.editModeInTps && (
                      <p>
                        <span>Exit edit mode</span>
                      </p>
                    )}
                  </div>
                  {isInEditModeInTps && (
                    <div
                      className={`${MultiGroupReportStyle.configurationButtons} row hidden-print`}
                    >
                      <ConfigurationViewButton
                        visible={isMultiGroupOrSingleGroupReport}
                        onClick={() => MultiShotHelpers.toggleTab(this.reportStore, 'dispersionOn')}
                        classNameForViewButton="dispersion-tab"
                        enabled={this.reportStore.dispersionOn}
                        buttonName="Dispersion"
                        buttonIcon="Images/dispersion-icon.svg"
                      />
                      <ConfigurationViewButton
                        visible={isMultiGroupOrSingleGroupReport}
                        onClick={() => MultiShotHelpers.toggleTab(this.reportStore, 'trajectoryOn')}
                        classNameForViewButton="trajectory-tab"
                        enabled={this.reportStore.trajectoryOn}
                        buttonName="Trajectory"
                        buttonIcon="Images/trajectory-icon.svg"
                      />
                      <ConfigurationViewButton
                        visible={isMultiGroupOrSingleGroupReport}
                        onClick={() => MultiShotHelpers.toggleTab(this.reportStore, 'optimizerOn')}
                        classNameForViewButton="optimizer-tab"
                        enabled={this.reportStore.optimizerOn}
                        buttonName="Optimizer"
                        buttonIcon="Images/optimizer-icon.svg"
                      />
                      <ConfigurationViewButton
                        visible={isMultiGroupOrSingleGroupReport}
                        onClick={() => MultiShotHelpers.toggleTab(this.reportStore, 'clubDataOn')}
                        classNameForViewButton="club-data-tab"
                        enabled={this.reportStore.clubDataOn}
                        buttonName="Club data"
                        buttonIcon="Images/club-data-icon.svg"
                      />
                      <ConfigurationViewButton
                        visible={this.reportStore.reportHasAtLeastOneVideo}
                        onClick={() => MultiShotHelpers.toggleTab(this.reportStore, 'videoOn')}
                        classNameForViewButton="video-tab"
                        enabled={this.reportStore.videoOn}
                        buttonName="Video"
                        buttonIcon="Images/video-icon.svg"
                      />
                      <ConfigurationViewButton
                        visible={isPuttingMultiGroupOrPuttingSingleGroupReport}
                        onClick={() =>
                          MultiShotHelpers.toggleTab(this.reportStore, 'skidAndRollOn')
                        }
                        classNameForViewButton="skid-and-roll-tab"
                        enabled={this.reportStore.skidAndRollOn}
                        buttonName="Skid and Roll"
                        buttonIcon=""
                      />
                      <ConfigurationViewButton
                        visible={true}
                        onClick={() => MultiShotHelpers.toggleCommercial(this.reportStore)}
                        classNameForViewButton="tmu-commercial"
                        enabled={this.reportStore.showBottomCommercial}
                        buttonName="Commercial"
                        buttonIcon=""
                      />
                    </div>
                  )}
                </div>
              )}
              {this.reportStore.isTps && (
                <div className="visible-print-block">
                  <HeaderWithCommercials {...this.getHeaderWithCommercialProps()} />
                </div>
              )}
              {this.reportStore.isWeb && (
                <div>
                  <HeaderWithCommercials {...this.getHeaderWithCommercialProps()} />
                </div>
              )}
              <div className="row hidden-print">
                <InstructorMessageControl
                  {...{
                    ...this.reportStore,
                    ...{
                      onInstructorMessageChanged: message =>
                        (this.reportStore.instructorMessage = message),
                    },
                  }}
                />
              </div>
              <div className="hidden-print">
                <div className={`${MultiGroupReportStyle.individualPlayerShots} row`}>
                  {this.reportStore.individualPlayers.map((currentPlayer, i) => {
                    const strokeGroupsBtns = this.reportStore.measurementsData.map(
                      (measurementGroup, j) => {
                        if (
                          measurementGroup.player &&
                          measurementGroup.player.id === currentPlayer.id
                        ) {
                          return (
                            <StrokesGroupButton
                              key={measurementGroup.id + j}
                              reportKind={this.reportStore.reportKind}
                              measurementGroup={measurementGroup}
                              groupIndex={j}
                              displayStrokesGroup={this.displayStrokesGroup}
                              unitPresentation={this.reportStore.unitPresentation}
                              selectedUnit={this.reportStore.selectedUnit}
                              className=""
                            />
                          );
                        }
                        return null;
                      }
                    );

                    if (currentPlayer) {
                      return [
                        <div className={`${MultiGroupReportStyle.playerInfo} col-xs-12`} key={i}>
                          <div className={MultiGroupReportStyle.playerImg}>
                            {this.reportStore.isWeb && (
                              <img
                                src={ImageHandler.getImageUrl(currentPlayer.id)}
                                alt=""
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src = 'Images/no-avatar.png';
                                }}
                              />
                            )}
                            {!this.reportStore.isWeb && currentPlayer.image && (
                              <img src={currentPlayer.image} alt="" />
                            )}
                            {!this.reportStore.isWeb && !currentPlayer.image && (
                              <img src={'Images/no-avatar.png'} alt="" />
                            )}
                          </div>
                          <span className={MultiGroupReportStyle.playerName}>
                            {currentPlayer.name}
                          </span>
                        </div>,
                        strokeGroupsBtns,
                      ];
                    }
                    return null;
                  })}
                </div>
              </div>

              {/* {isMultiGroupOrSingleGroupReport && (
                <NormalizationSettings
                  disabled={this.state.isUpdatingReport}
                  isActive={this.reportStore.showNormalizedData}
                  setIsActive={this.toggleNormalization}
                  value={this.reportStore.normalizationSettings}
                  onChange={this.setNormalizationSettings}
                />
              )} */}

              <div id="view-buttons" className="row">
                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.dispersionOn) &&
                    isMultiGroupOrSingleGroupReport
                  }
                  view={Data.ViewType.Dispersion}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.Dispersion, this.reportStore)
                  }
                  classNameForViewButton="dispersion-tab"
                  enabled={this.reportStore.dispersionOn}
                  buttonName="Dispersion"
                  buttonIconSelected="Images/dispersion-icon-white.svg"
                  buttonIconNotSelected="Images/dispersion-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />
                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.trajectoryOn) &&
                    isMultiGroupOrSingleGroupReport
                  }
                  view={Data.ViewType.Trajectory}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.Trajectory, this.reportStore)
                  }
                  classNameForViewButton="trajectory-tab"
                  enabled={this.reportStore.trajectoryOn}
                  buttonName="Trajectory"
                  buttonIconSelected="Images/trajectory-icon-white.svg"
                  buttonIconNotSelected="Images/trajectory-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />
                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.optimizerOn) &&
                    isMultiGroupOrSingleGroupReport
                  }
                  view={Data.ViewType.Optimizer}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.Optimizer, this.reportStore)
                  }
                  classNameForViewButton="optimizer-tab"
                  enabled={this.reportStore.optimizerOn}
                  buttonName="Optimizer"
                  buttonIconSelected="Images/optimizer-icon-white.svg"
                  buttonIconNotSelected="Images/optimizer-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />
                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.clubDataOn) &&
                    isMultiGroupOrSingleGroupReport
                  }
                  view={Data.ViewType.ClubData}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.ClubData, this.reportStore)
                  }
                  classNameForViewButton="club-data-tab"
                  enabled={this.reportStore.clubDataOn}
                  buttonName="Club data"
                  buttonIconSelected="Images/club-data-icon-white.svg"
                  buttonIconNotSelected="Images/club-data-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />
                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.videoOn) &&
                    this.reportStore.reportHasAtLeastOneVideo
                  }
                  view={Data.ViewType.Video}
                  onClick={() => MultiShotHelpers.selectView(Data.ViewType.Video, this.reportStore)}
                  classNameForViewButton="video-tab"
                  enabled={this.reportStore.videoOn}
                  buttonName="Video"
                  buttonIconSelected="Images/video-icon-white.svg"
                  buttonIconNotSelected="Images/video-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />
                <ViewButton
                  visible={
                    (isInEditModeInTps || this.reportStore.skidAndRollOn) &&
                    isPuttingMultiGroupOrPuttingSingleGroupReport
                  }
                  view={Data.ViewType.SkidAndRoll}
                  onClick={() =>
                    MultiShotHelpers.selectView(Data.ViewType.SkidAndRoll, this.reportStore)
                  }
                  classNameForViewButton="skid-and-roll-tab"
                  enabled={this.reportStore.skidAndRollOn}
                  buttonName="Skid and Roll"
                  buttonIconSelected="Images/video-icon-white.svg"
                  buttonIconNotSelected="Images/video-icon.svg"
                  selectedView={this.reportStore.selectedView}
                />
              </div>
              {/* TODO Consider if adding this check here is neccessary: this.reportStore.measurementsData.length !== 0 &&*/}
              <div className="printed-first-page visible-print-block">
                <div className="report-printed-paragraph visible-print-block">
                  <h1>TrackMan Report</h1>
                </div>
                <div className="row visible-print-block">
                  <InstructorMessageControl {...this.getInstructorMessageParameters()} />
                </div>
                {this.reportStore.isWeb && (
                  <div className="visible-print-block sponsor-details">
                    <SponsorDetails {...this.getSponsorDetailsParameters()} />
                  </div>
                )}
              </div>
              {this.reportStore.selectedView !== Data.ViewType.NotSpecified &&
                isMultiGroupOrSingleGroupReport && (
                  <div className="printed-second-page visible-print-block">
                    <h2
                      className={`${MultiGroupReportStyle.printedPageTitleText} visible-print-block`}
                    >
                      Dispersion
                    </h2>
                    <div className={`dispersion-control col-xs-12 ${isDisabledDispersionView}`}>
                      <DispersionControl {...this.getDispersionControlParametres()} />
                    </div>
                    {/*Add the legends in the print - maybe as a component??*/}
                    <PrintedLegends {...this.getPrintedLegendsProps()} />
                  </div>
                )}

              {this.reportStore.selectedView !== Data.ViewType.NotSpecified &&
                isMultiGroupOrSingleGroupReport && (
                  <div className={`${MultiGroupReportStyle.printedThirdPage} visible-print-block`}>
                    <h2
                      className={`${MultiGroupReportStyle.printedPageTitleText} visible-print-block`}
                    >
                      Trajectory
                    </h2>
                    <div className={isDisabledTrajectoryView}>
                      <TrajectoryControl {...this.getTrajectoryControlParameters()} />
                    </div>
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.Dispersion &&
                (this.reportStore.editModeInTps ||
                  (this.reportStore.dispersionOn && isMultiGroupOrSingleGroupReport)) && (
                  <div
                    className={`dispersion-control col-xs-12 hidden-print ${isDisabledDispersionView}`}
                  >
                    <DispersionControl {...this.getDispersionControlParametres()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.Trajectory &&
                (this.reportStore.editModeInTps ||
                  (this.reportStore.trajectoryOn && isMultiGroupOrSingleGroupReport)) && (
                  <div className={`trajectory-control hidden-print ${isDisabledTrajectoryView}`}>
                    <TrajectoryControl {...this.getTrajectoryControlParameters()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.Optimizer &&
                (this.reportStore.editModeInTps ||
                  (this.reportStore.optimizerOn && isMultiGroupOrSingleGroupReport)) && (
                  <div className={`hidden-print ${isDisabledOptimizerView}`}>
                    <OptimizerControl {...this.getOptimizerControlParametres()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.ClubData &&
                (this.reportStore.editModeInTps ||
                  (this.reportStore.clubDataOn && isMultiGroupOrSingleGroupReport)) && (
                  <div className={`hidden-print ${isDisabledClubDataView}`}>
                    <ClubControl {...this.getClubDataParameters()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.Video &&
                this.reportStore.reportHasAtLeastOneVideo &&
                (isInEditModeInTps || this.reportStore.videoOn) && (
                  <div className={`hidden-print ${isDisabledVideoView}`}>
                    <VideoControl {...this.getVideoParameters()} />
                  </div>
                )}
              {this.reportStore.selectedView === Data.ViewType.SkidAndRoll &&
                (this.reportStore.editModeInTps || this.reportStore.skidAndRollOn) &&
                isPuttingMultiGroupOrPuttingSingleGroupReport && (
                  <div className={`hidden-print skid-and-roll ${isDisabledSkidAndRollView}`}>
                    <SkidAndRollControl {...this.getSkidAndRollControlParametres()} />
                  </div>
                )}
              <MultiShotControl {...this.getMultiShotControlParametres()} />
              {isMultiGroupOrSingleGroupReport && (
                <div className="normalized-data-check">
                  <div
                    className={`glyphicon checkbox-icon glyphicon-check ${isNormalizedCheckNotChecked}`}
                    onClick={() => this.toggleNormalization(!this.reportStore.showNormalizedData)}
                  ></div>
                  <NormalizedCheckboxText {...this.getNormalizedCheckboxText()} />
                </div>
              )}
              {this.reportStore.isWeb && <ShareButtons {...this.getShareButtons()} />}
            </div>
          }
          {this.reportStore.noStrokes && <ReportWithNoData />}
          {<FooterWithCommercial {...this.getFooterWithCommercial()} />}
        </div>
      )
    );
  }
  private getHeaderWithCommercialProps() {
    const result: IHeaderWithCommercialProps = {
      individualPlayers: this.reportStore.individualPlayers,
      reportDate: this.reportStore.reportDate,
      sponsors: this.reportStore.sponsors,
      facilities: this.reportStore.facilities,
      reportKind: this.reportStore.reportKind,
      isWeb: this.reportStore.isWeb,
      isTps: this.reportStore.isTps,
    };
    return result;
  }

  private getShareButtons() {
    const result: IShareButtonsProps = {
      shareLink: this.reportStore.shareLink,
      reportKind: this.reportStore.reportKind,
      setShareLink: (link: string) => (this.reportStore.shareLink = link),
      onClickMailButton: this.onClickMailButton,
      shareOnTwitterOnClick: this.shareOnTwitterOnClick,
      shareOnFacebookOnClick: this.shareOnFacebookOnClick,
      reportPrintUrl: this.reportStore.reportPrintUrl,
    };
    return result;
  }
  private getFooterWithCommercial() {
    const result: IFooterWithCommercialProps = {
      showBottomCommercial: this.reportStore.showBottomCommercial,
      editModeInTps: this.reportStore.editModeInTps,
      isTps: this.reportStore.isTps,
    };
    return result;
  }

  private getNormalizedCheckboxText() {
    const result: INormalizedCheckboxTextProps = {
      reportKind: this.reportStore.reportKind,
      showNormalizedData: this.reportStore.showNormalizedData,
      normalizedEnvironmentDetails: this.reportStore.normalizedEnvironmentDetails,
      unitPresentation: this.reportStore.unitPresentation,
    };
    return result;
  }
  private getVideoParameters() {
    const result: IVideoControlProps = {
      videos: this.reportStore.videos,
      selectedVideos: this.reportStore.selectedVideos,
      showMultiGroupReport: true,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: this.reportStore.selectedAverage,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,
      isTps: this.reportStore.isTps,
      onSelectedVideosChanged: this.onSelectedVideosChanged,
    };
    return result;
  }
  private getTrajectoryControlParameters() {
    const result: ITrajectoryControlParams = {
      measurementsData: this.reportStore.measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      showNormalizedData: this.reportStore.showNormalizedData,
      selectedAverage: this.reportStore.selectedAverage,
      selectedClub: this.reportStore.clubType,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,
      onSelectStroke: this.onSelectStroke,
      onCleanSelectedShot: this.onCleanSelectedShot,
    };
    return result;
  }
  private getInstructorMessageParameters() {
    const result: IInstructorMessageControlProps = {
      instructorId: this.reportStore.instructorId,
      instructorMessage: this.reportStore.instructorMessage,
      instructorImage: this.reportStore.instructorImage,
      instructorName: this.reportStore.instructorName,
      isWeb: this.reportStore.isWeb,
      isTps: this.reportStore.isTps,
      onInstructorMessageChanged: this.onInstructorMessageChanged,
    };
    return result;
  }
  private getSponsorDetailsParameters() {
    const result: ISponsorDetailsProps = {
      sponsors: this.reportStore.sponsors,
      facilities: this.reportStore.facilities,
      isWeb: this.reportStore.isWeb,
      isTps: this.reportStore.isTps,
    };
    return result;
  }
  private getDispersionControlParametres() {
    const result: IDispersionControlProps = {
      measurementsData: this.reportStore.measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedAverage: this.reportStore.selectedAverage,
      selectedClub: this.reportStore.clubType,
      multiShotReportDataService: this.reportDataService,
      selectedDispersionMode: Data.GetDispersionMode(this.reportStore.selectedDispersionMode),
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,

      onDispersionModeChange: this.onDispersionModeChange,
      onSelectedStrokeChange: this.onSelectedStrokeChange,
      onSelectedClubChange: this.onSelectedClubChange,
      onSelectedGroupOfStrokesChange: this.onSelectedGroupOfStrokesChange,
      onSelectedAverageChange: this.onSelectedAverageChange,
    };
    return result;
  }
  private getOptimizerControlParametres() {
    const result: IOptimizerControlParams = {
      measurementsData: this.reportStore.selectedStroke,
      reportDataService: this.reportDataService,
      unitPresentation: this.reportStore.unitPresentation,
      clubType: this.reportStore.clubType,
      selectedStroke: this.reportStore.selectedStroke,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedAverage: this.reportStore.selectedAverage,
      selectedOptimizerView: this.reportStore.selectedOptimizerView,
      selectedView: this.reportStore.selectedView,
      selectedOptimizedType: this.reportStore.selectedOptimizedType,
      defaultOptimizedTypes: Data.DefaultOptimizedTypes,
      showNormalizedData: this.reportStore.showNormalizedData,
      reportId: this.reportStore.reportId,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      isTps: this.reportStore.isTps,
      isWeb: this.reportStore.isWeb,
      reportKind: this.reportStore.reportKind,
      showOptimizerTutorial: this.reportStore.showOptimizerTutorial,
      hideOptimizerTutorial: this.hideOptimizerTutorial,
      selectOptimizerView: this.selectOptimizerView,
      selectOptimizedType: this.selectOptimizedType,
      doNotShowOptimizerAgain: this.doNotShowOptimizerAgain,
    };
    return result;
  }
  private getClubDataParameters() {
    const result: IClubControlProps = {
      measurementsData: this.reportStore.selectedStroke,
      clubType: this.reportStore.clubType,
      unitPresentation: this.reportStore.unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: this.reportStore.selectedAverage,
      isTps: this.reportStore.isTps,
      isIos: this.reportStore.isIos,
      isWeb: this.reportStore.isWeb,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      reportKind: this.reportStore.reportKind,
      //setAdditionalInfoUrl: this.setAdditionalInfoUrl
    };
    return result;
  }
  private getMultiShotControlParametres() {
    const unitPresentation = this.reportStore.unitPresentation;
    const measurementParameters = this.reportStore.measurementParameters;
    const selectedGroupOfStrokes = this.reportStore.selectedGroupOfStrokes;
    const selectedAverage = this.reportStore.selectedAverage;

    const result: IMultiShotControlParams = {
      reportKind: this.reportStore.reportKind,
      measurementsData: this.reportStore.measurementsData,
      unitPresentation: unitPresentation,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: selectedAverage,
      selectedGroupOfStrokes: selectedGroupOfStrokes,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      selectedClub: this.reportStore.clubType,
      tilesToDisplay: this.reportStore.tilesToDisplay,
      selectedView: this.reportStore.selectedView,
      showNormalizedData: this.reportStore.showNormalizedData,
      videos: this.reportStore.videos,
      individualPlayers: this.reportStore.individualPlayers,
      isTps: this.reportStore.isTps,
      isIos: this.reportStore.isIos,
      isWeb: this.reportStore.isWeb,
      multiShotReportDataService: this.reportDataService,
      measurementParameters: measurementParameters,
      sponsors: this.reportStore.sponsors,
      facilities: this.reportStore.facilities,
      cleanSelectedShot: this.cleanSelectedShot,
      selectShot: this.selectShot,
      selectVideo: this.selectVideo,
      disableTile: this.disableTile,
      hideSingleShot: this.hideSingleShot,
      selectAverage: this.selectAverage,
      collapseStrokesGroup: this.collapseStrokesGroup,
      loadTiles: this.loadTiles,
      updateUnitOnTiles: this.updateUnitOnTiles,
      addTile: this.addTile,
      changeUnit: this.changeUnit,
      displayStrokesGroup: this.displayStrokesGroup,
      selectedUnit: this.reportStore.selectedUnit,
      reportStore: this.reportStore,
    };
    return result;
  }

  private getPrintedLegendsProps() {
    const result: IPrintedLegendsProps = {
      measurementsData: this.reportStore.measurementsData,
      individualPlayers: this.reportStore.individualPlayers,
      unitPresentation: this.reportStore.unitPresentation,
    };
    return result;
  }

  private getSkidAndRollControlParametres() {
    let measurementsData;

    if (this.reportStore.selectedAverage) {
      measurementsData = this.reportStore.selectedAverage;
    } else if (this.reportStore.selectedStroke) {
      measurementsData = this.reportStore.selectedStroke;
    }

    const result: ISkidAndRollControlParams = {
      measurementsData: measurementsData,
      unitPresentation: this.reportStore.unitPresentation,
      clubType: this.reportStore.clubType,
      selectedGroupOfStrokes: this.reportStore.selectedGroupOfStrokes,
      selectedStroke: this.reportStore.selectedStroke,
      selectedAverage: this.reportStore.selectedAverage,
      //onDataTypeChanged: this.reportStore.onDataTypeChanged,
      selectedView: this.reportStore.selectedView,
      selectedStrokesGroups: this.reportStore.selectedStrokesGroups,
      isTps: this.reportStore.isTps,
      isWeb: this.reportStore.isWeb,
      reportKind: this.reportStore.reportKind,
      widthOfContainer: 1140, //450 for putting compare report
      heightOfContainer: 554, //455 for height in the compare report
      containerMarginTop: 73, //60 for putting compare report
      containerMarginBottom: 102, //103 for putting compare report
      containerMarginLeft: 137, //35 for putting compare report
      containerMarginRight: 136, //50 for putting compare report
    };
    return result;
  }
}
